import React, { useState, useRef } from 'react';
import { Checkbox, Modal } from '@cimpress/react-components';
import { css } from 'react-emotion';
import { actions as termActions } from '../../../reducers/terms';
import { connect } from 'react-redux';
import useForm from 'react-hook-form';
import { useAsyncCallback } from 'react-async-hook';
import ErrorText from '../createContract/buyerFlow/Shared/ErrorText';
import isNil from 'lodash/isNil';
import { useTranslation } from 'react-i18next';

const buttonStyle = css`
  margin-top: 10px;
  margin-left: 10px;
  float: right;
`;

export function EditGracePeriodModal({
  setLatestRevision,
  onCloseModal,
  modalOpened,
  updateTermGracePeriod,
  days: initialDays
}) {
  const { t } = useTranslation();

  const [noGracePeriod, setNoGracePeriod] = useState(isNil(initialDays));

  // Need this ref so the validate function gets the latest value. https://github.com/facebook/react/issues/14010
  const noGracePeriodRef = useRef(noGracePeriod);
  noGracePeriodRef.current = noGracePeriod;

  const onSubmit = data =>
    updateTermGracePeriod(noGracePeriodRef.current ? null : data.days).then(({ payload }) =>
      setLatestRevision(payload)
    );

  const { register, handleSubmit, errors: formErrors } = useForm({
    defaultValues: { days: initialDays }
  });
  const { execute, loading, error: submitError } = useAsyncCallback(onSubmit);

  return (
    <Modal
      show={modalOpened}
      onRequestHide={onCloseModal}
      title={t('contractActions:editGracePeriodModal.title')}
      closeButton
      closeOnOutsideClick>
      <form onSubmit={handleSubmit(execute)}>
        <div className="form-group required">
          <input
            disabled={noGracePeriod}
            required
            className="form-control"
            name="days"
            type="number"
            ref={register({
              validate: {
                validRange: value => {
                  return (value > 0 && value < 1000) || t('contractActions:editGracePeriodModal.validateRangeMessage');
                },
                unique: value => {
                  if (noGracePeriodRef.current) {
                    return !isNil(initialDays) || t('contractActions:validateUniqueMessage');
                  }
                  return parseInt(value) !== parseInt(initialDays) || t('contractActions:validateUniqueMessage');
                },
                required: value => noGracePeriodRef.current || !!value.trim() || t('contractActions:requiredMessage')
              }
            })}
          />
          {formErrors.days && <ErrorText text={formErrors.days.message} />}
        </div>
        <Checkbox
          label={t('contractActions:editGracePeriodModal.checkboxLabel')}
          checked={noGracePeriod}
          onChange={() => {
            setNoGracePeriod(!noGracePeriod);
          }}
        />

        <button className={`btn btn-primary ${buttonStyle}`} type="submit" disabled={loading}>
          {t('contractActions:saveAndUpdate')}
        </button>
        <button className={`btn btn-default ${buttonStyle}`} type="button" disabled={loading} onClick={onCloseModal}>
          {t('common:commonWords.cancel')}
        </button>
        {submitError && (
          <ErrorText text={submitError.payload ? submitError.payload.message : JSON.stringify(submitError)} />
        )}
      </form>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { termRevision } = ownProps;
  return {
    updateTermGracePeriod: days =>
      dispatch(termActions.updateTermGracePeriod(termRevision.termId, termRevision.revisionId, days))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(EditGracePeriodModal);
